import { SkeletonLoader } from '@lab39/react-ui';
import styles from './HomePageSkeleton.module.css';

const HomePageSkeleton = () => {
  return (
    <div className={styles.wrapper}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className="container">
          <div className={styles.heroContent}>
            <SkeletonLoader variant="text" width="60%" height="48px" />
            <SkeletonLoader variant="text" width="80%" height="24px" />
            <div className={styles.heroStats}>
              <div className={styles.heroStat}>
                <SkeletonLoader variant="text" width="60px" height="36px" />
                <SkeletonLoader variant="text" width="80px" height="16px" />
              </div>
              <div className={styles.heroStat}>
                <SkeletonLoader variant="text" width="60px" height="36px" />
                <SkeletonLoader variant="text" width="80px" height="16px" />
              </div>
              <div className={styles.heroStat}>
                <SkeletonLoader variant="text" width="60px" height="36px" />
                <SkeletonLoader variant="text" width="80px" height="16px" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        {/* Featured Tools Section */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <SkeletonLoader variant="text" width="200px" height="32px" />
            <SkeletonLoader variant="text" width="300px" height="20px" />
          </div>
          
          <div className={styles.featuredGrid}>
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className={styles.toolCard}>
                <SkeletonLoader variant="rectangular" width="100%" height="200px" />
              </div>
            ))}
          </div>
        </section>

        {/* Category Section */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <SkeletonLoader variant="text" width="280px" height="32px" />
            <SkeletonLoader variant="text" width="320px" height="20px" />
          </div>

          <div className={styles.categorySection}>
            <div className={styles.categoryHeader}>
              <SkeletonLoader variant="text" width="180px" height="28px" />
            </div>
            
            <div className={styles.categoryGrid}>
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className={styles.toolCard}>
                  <SkeletonLoader variant="rectangular" width="100%" height="160px" />
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePageSkeleton;
